import { render, staticRenderFns } from "./PrevNext.vue?vue&type=template&id=32def7e3&scoped=true&"
import script from "./PrevNext.vue?vue&type=script&lang=ts&"
export * from "./PrevNext.vue?vue&type=script&lang=ts&"
import style0 from "./PrevNext.vue?vue&type=style&index=0&id=32def7e3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32def7e3",
  null
  
)

export default component.exports